import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import {
    createHeadline,
    Headline,
} from '@vfde-brix/headline';
import { ADDITIONAL_PAGE_OPTIONS, SALESCHANNEL_REDPLUS, SALESCHANNEL_SOHO } from '@vfde-fe/sails-constants';
import replaceCMSPlaceholder from '../helpers/replaceCMSPlaceholder';

/**
 * Mount the headline
 * @param selector
 */
export const mountHeadline = (selector: string): Headline => {
    const container = document.getElementById(selector);

    return container && createHeadline(container, NO_PATTERN_BUSINESS_LOGIC);
};

/**
 * Update headline
 *
 * @param headline
 * @param name
 * @param isHardwareOnly
 * @param salesChannel
 */
export const updateHeadline = (headline: Headline, name: string, isHardwareOnly: boolean, salesChannel: string): void => {
    let headlineSuffix = window[ADDITIONAL_PAGE_OPTIONS].headline;
    const { hardwareOnly, redplus } = window[ADDITIONAL_PAGE_OPTIONS];

    switch (true) {
        case isHardwareOnly:
            headlineSuffix = hardwareOnly.headline;
            break;
        case salesChannel === SALESCHANNEL_REDPLUS:
            headlineSuffix = redplus.headline;
            break;
    }

    headline.update({stdContent: `${name} ${headlineSuffix}`});
};

/**
 * Update subline
 *
 * @param sublineElement
 * @param state
 */
export const updateSubline = (sublineElement: Headline, state): void => {
    let sublineSuffix = window[ADDITIONAL_PAGE_OPTIONS].subline;
    const { soho } = window[ADDITIONAL_PAGE_OPTIONS];
    const { salesChannel, offer, hasSubscription, isHardwareOnly} = state;
    const { name } = offer;

    if (!hasSubscription || isHardwareOnly) {
        sublineElement.hideContainer();

        return;
    }

    if (salesChannel === SALESCHANNEL_SOHO) {
        sublineSuffix = soho.subline;
    }

    const sublineContent = replaceCMSPlaceholder(sublineSuffix, {tariffName: name});
    sublineElement.update({stdContent: sublineContent});
    sublineElement.showContainer();
};
